function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "axprr7j5na"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/search (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/search",
    style: {
      clipPath: "url(#axprr7j5na)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/search (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/search (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.074 17.187a.17.17 0 0 1-.067-.013.18.18 0 0 1-.058-.038l-5.579-5.578A6.445 6.445 0 0 1 1.888 11 6.445 6.445 0 0 1 6.445 0a6.447 6.447 0 0 1 6.446 6.445 6.364 6.364 0 0 1-1.334 3.928l5.579 5.579a.176.176 0 0 1 .038.057.18.18 0 0 1 0 .135.176.176 0 0 1-.038.057l-.937.935a.168.168 0 0 1-.057.038.173.173 0 0 1-.068.013zM6.445 1.633a4.811 4.811 0 1 0 3.4 1.409 4.792 4.792 0 0 0-3.4-1.409z",
    transform: "translate(2.406 2.406)",
    style: {
      fill: "#d9d9d9"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a2d489bff80e5005836e83179854b22b.svg";
export { ForwardRef as ReactComponent };